

















import {defineComponent, PropType} from '@vue/composition-api'
import {ISlide} from '../../models/slide'

import HeadingAtom from '@/shared/components/atoms/HeadingAtom.vue'
import IconLinkAtom from '@/shared/components/atoms/IconLinkAtom.vue'

export default defineComponent({
    name: 'IntroComponent',
    components: {
        HeadingAtom,
        IconLinkAtom
    },
    props: {
        slide: {
            type: Object as PropType<ISlide>,
            required: true
        },
        showIntroText: {
            type: Boolean,
            default: false
        },
        showLink: {
            type: Boolean,
            required: true,
            default: false
        },
        iconLinkClass: {
            type: String,
            default: ''
        }
    }
})
